import Index from "../components/root/Index.vue"
import init from "../root_init"
init(Index)
